export const globalVariables = {
    // ========================
    // BASIC CONFIGURATION
    // ========================
    COMPANY_NAME: 'FlyWind',
    COOKIE_POLICY_LINK: '/cookie-policy',
    WEBSITE_URL: 'https://flywindva.com/',
    LAST_UPDATED_DATE: 'September 13, 2025', //Privacy Policy
    LIST_SPECIFIC_PROVIDERS_IF_KNOWN: 'none',
    CONTACT_EMAIL: 'info@flywindva.com',
    SPECIFY_RETENTION_PERIOD: 'two years after account inactivity',
    MINIMUM_AGE: '13',
    DPO_EMAIL: 'info@flywindva.com',
    OACI: "FWN",
    API_URL: 'https://api.flywindva.com/',

    // ========================
    // VIEW LINKS
    // ========================
    LINK_VIEW_1: 'https://diazro.me/hicrew',
    LINK_VIEW_2: 'https://www.ivao.aero/',
    LINK_VIEW_3: 'https://mx.ivao.aero/',
    LINK_VIEW_4: '#',

    // ========================
    // PAGE TITLE
    // ========================
    // Change this title to customize your airline's title
    PAGE_TITLE: 'FlyWind VA',

    // ========================
    // CUSTOMIZABLE TRANSLATIONS
    // ========================
    // Here you can override the default translations
    // Only modify the texts, keep the structure
    CUSTOM_TRANSLATIONS: {
        welcome: {
            ES: "Bienvenido a",
            EN: "Welcome to",
            FR: "Bienvenue à",
            PT: "Bem-vindo ao",
            IT: "Benvenuto a",
            CA: "Benvingut a",
            EU: "Ongi etorri",
            GL: "Benvido a"
        },
        title: {
            ES: "FlyWind!",
            EN: "FlyWind!",
            FR: "FlyWind!",
            PT: "FlyWind!",
            IT: "FlyWind!",
            CA: "FlyWind!",
            EU: "FlyWind!",
            GL: "FlyWind!"
        },
        slogan: {
            ES: "Conectando desde lo alto",
            EN: "Connecting from the top",
            FR: "Connecting from the top",
            PT: "Connecting from the top",
            IT: "Connecting from the top",
            CA: "Connecting from the top",
            EU: "Connecting from the top",
            GL: "Connecting from the top"
        },
        info: {
            ES: "Sin ACARS, es fácil, solo vuela, solo o con tus amigos.",
            EN: "No acars, is easy only fly, alone or with your friends.",
            FR: "Sans ACARS, c'est facile, il suffit de voler, seul ou avec vos amis.",
            PT: "Sem ACARS, é fácil, apenas voe, sozinho ou com seus amigos.",
            IT: "Senza ACARS, è facile, basta volare, da soli o con i tuoi amici.",
            CA: "Sense ACARS, és fàcil, només vola, sol o amb els teus amics.",
            EU: "ACARS gabe, erraza da, hegan egin besterik ez, bakarrik edo zure lagunekin.",
            GL: "Sen ACARS, é fácil, só voa, só ou cos teus amigos."
        }
    }
};